var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPillImg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u110E\\u116E\\u11AF\\u1110_\\u1100\\u1173\\u11AB",
    "data-name": "\\u110E\\u116E\\u11AF\\u1110\\u116C\\u1100\\u1173\\u11AB",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.74,
    height: 20.736,
    viewBox: "0 0 20.74 20.736",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Export-_x28_Final---R1_x29__33_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "person_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "head",
    d: "M170.3,104.5a3.7,3.7,0,1,1-3.6,3.7A3.649,3.649,0,0,1,170.3,104.5Zm0,1.483a2.227,2.227,0,1,0,2.115,2.224,2.17,2.17,0,0,0-2.115-2.224Z",
    transform: "translate(-159.927 -100.267)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "body-and-circle",
    d: "M9.87,0a10.37,10.37,0,0,1,5.136,19.379,10.167,10.167,0,0,1-4.954,1.357H9.87A10.368,10.368,0,1,1,9.87,0ZM8.9,14.178a4.448,4.448,0,0,0-4.2,2.989l-.1.308a8.8,8.8,0,0,0,5.177,1.782h.235a8.8,8.8,0,0,0,4.3-1.191l.818-.543-.093-.28a4.446,4.446,0,0,0-4.144-3.066Zm.968-12.7A8.887,8.887,0,0,0,3.389,16.45,5.928,5.928,0,0,1,8.9,12.7h1.916a5.927,5.927,0,0,1,5.521,3.771A8.886,8.886,0,0,0,9.87,1.483Z",
    transform: "translate(0.5)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPillImg1);
export default __webpack_public_path__ + "static/media/pill_img_1.a39f8101850e91c2e8f7ee401d245eb4.svg";
export { ForwardRef as ReactComponent };